export default "__VITE_ASSET__Cot7GXB0__"